import * as React from "react";
import TopLayout from "./modules/views/TopLayout";
import Achievements from "./modules/views/Achievements";
import Band from "./modules/views/Band";
import PhotoStrip from "./modules/views/PhotoStrip";
import About from "./modules/views/About";
import RoboCupIntro from "./modules/views/RoboCupIntro";
import Projects from "./modules/views/Projects";
import Members from "./modules/views/Members";
import Location from "./modules/views/Location";
import Partners from "./modules/views/Partners";
import Contact from "./modules/views/Contact";
import AppFooter from "./modules/views/AppFooter";
import ResponsiveAppBar from "./modules/views/ResponsiveAppBar";
import useScrollReveal from "./modules/useScrollReveal";

import FieldWideImg from "./assets/robocup2026/web/field_wide.jpg";
import PartyImg from "./assets/robocup2026/web/party.jpg";
import PitWorkImg from "./assets/robocup2026/web/pit_work.jpg";
import RobotBallImg from "./assets/robocup2026/web/robot_ball_field.jpg";
import StandbyImg from "./assets/robocup2026/web/standby.jpg";
import BoothImg from "./assets/robocup2026/web/booth.jpg";
import StickersImg from "./assets/robocup2026/web/stickers.jpg";
import BannerImg from "./assets/robocup2026/web/banner.jpg";
import ArrivalImg from "./assets/robocup2026/web/arrival.jpg";
import HotelImg from "./assets/robocup2026/web/hotel.jpg";
import VenuePitImg from "./assets/robocup2026/web/venue_pit.jpg";
import RobotFleetImg from "./assets/robocup2026/web/robot_fleet.jpg";
import PaddockImg from "./assets/robocupjo2025/paddock.png";
import KickTestVideo from "./assets/kick_test_web.mp4";

const ABOUT_PHOTOS = [
  { image: RobotFleetImg, alt: "開発したTRAPSのSSLロボット群" },
  { image: PaddockImg, alt: "大会ピットでロボットを手作業するTRAPSメンバー" },
  { video: KickTestVideo, alt: "TRAPSのSSLロボットによるキックテスト" },
];

const DEVELOPMENT_PHOTOS = [
  { image: PitWorkImg, alt: "フィールド上でロボットを整備するTRAPSメンバー" },
  { image: RobotBallImg, alt: "ボールと対峙するTRAPSのSSLロボット" },
  { image: StandbyImg, alt: "試合に向けて待機するTRAPSのロボットと機材" },
];

const TEAM_PHOTOS = [
  { image: BoothImg, alt: "TRAPSのロボットが並ぶ大会ブース" },
  { image: StickersImg, alt: "各国のチームと交換したステッカー" },
  { image: BannerImg, alt: "TRAPSのフラッグとシャチのマスコット" },
];

const PEOPLE_PHOTOS = [
  { image: ArrivalImg, alt: "荷物を持って大会会場へ向かうTRAPSメンバー" },
  { image: HotelImg, alt: "宿泊先でRoboCupの試合を見守るTRAPSメンバー" },
  { image: VenuePitImg, alt: "大会ピットで準備を進めるTRAPSメンバー" },
];

function Reveal({ children }) {
  return <div className="trps-reveal">{children}</div>;
}

function Index() {
  useScrollReveal();

  return (
    <React.Fragment>
      <ResponsiveAppBar />
      <TopLayout />

      <Reveal><Achievements /></Reveal>

      <Reveal>
        <Band
          image={FieldWideImg}
          alt="RoboCup 2026 Incheonのフィールドで調整を行うTRAPSメンバー"
        />
      </Reveal>

      <Reveal><About /></Reveal>

      <Reveal><RoboCupIntro /></Reveal>

      <Reveal>
        <PhotoStrip photos={ABOUT_PHOTOS} reverse />
      </Reveal>

      <Reveal><Projects /></Reveal>

      <Reveal>
        <PhotoStrip photos={DEVELOPMENT_PHOTOS} />
      </Reveal>

      <Reveal><Members /></Reveal>

      <Reveal>
        <Band
          image={PartyImg}
          alt="大会後に集うTRAPSメンバー"
        />
      </Reveal>

      <Reveal><Location /></Reveal>

      <Reveal>
        <PhotoStrip photos={TEAM_PHOTOS} reverse />
      </Reveal>

      <Reveal><Partners /></Reveal>

      <Reveal>
        <PhotoStrip photos={PEOPLE_PHOTOS} />
      </Reveal>

      <Reveal><Contact /></Reveal>
      <AppFooter />
    </React.Fragment>
  );
}

export default Index;
